/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { PlayerModel, PlayerModelType } from './PlayerModel'
import { PlayerModelSelector } from './PlayerModel.base'
import { RootStoreType } from './index'

/**
 * ThreeCardDailyGameStatsBase
 * auto generated base class for the model ThreeCardDailyGameStatsModel.
 */
export const ThreeCardDailyGameStatsModelBase = ModelBase.named('ThreeCardDailyGameStats')
  .props({
    __typename: types.optional(types.literal('ThreeCardDailyGameStats'), 'ThreeCardDailyGameStats'),
    hand: types.union(types.undefined, types.number),
    players: types.union(types.undefined, types.array(types.late(() => PlayerModel))),
    winners: types.union(types.undefined, types.frozen())
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ThreeCardDailyGameStatsModelSelector extends QueryBuilder {
  get hand() {
    return this.__attr('hand')
  }
  get winners() {
    return this.__attr('winners')
  }
  players(
    builder: string | PlayerModelSelector | ((selector: PlayerModelSelector) => PlayerModelSelector) | undefined
  ) {
    return this.__child('players', PlayerModelSelector, builder)
  }
}
export function selectFromThreeCardDailyGameStats() {
  return new ThreeCardDailyGameStatsModelSelector()
}

export const threeCardDailyGameStatsModelPrimitives = selectFromThreeCardDailyGameStats().hand.winners
